const getTrackingTimelineItemStyles = theme => ({
  position: 'relative',
  display: 'flex',
  listStyle: 'none',
  marginBottom: theme.spacing(4),
  ':last-child': {
    marginBottom: 0
  }
});
const getTrackingTimelineLastUpdateLabelStyles = isSingleCheckpoint => theme => {
  const labelWidth = theme.spacing(11);
  return {
    position: 'absolute',
    top: isSingleCheckpoint ? theme.spacing(1.25) : theme.spacing(0.25),
    left: `-${labelWidth}px`,
    maxWidth: labelWidth,
    overflow: 'hidden'
  };
};
const getTrackingTimelineCheckpointDecorationStyles = theme => ({
  flex: `0 0 ${theme.spacing(6)}px`
});
const getTrackingCheckpointStyles = {
  flex: '1 1 auto'
};

export { getTrackingCheckpointStyles, getTrackingTimelineCheckpointDecorationStyles, getTrackingTimelineItemStyles, getTrackingTimelineLastUpdateLabelStyles };
//# sourceMappingURL=TrackingTimelineStyles.js.map
